import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../et3-enhanced-render";
import getTBWStore from "../../../stores/developer-store/tbw-store";
import { TCorePage, TTBWExtraData } from "../../../Types";
import Et3Button from "../../et3-button";

const BanButton = withLiteObserverAndTheme<{
  extraData: TTBWExtraData;
  fromPage: TCorePage;

  disabled: boolean;
  size: "COMPACT" | "MEDIUM" | "SMALL" | "LARGE" | "DEFAULT";
}>((props) => {
  const {
    extraData,
    fromPage,

    disabled,
    size
  } = props;
  return (
    <Et3Button
      onClick={async () => {
        await getTBWStore().showActionTBWPopUp({
          type: "ACTION_TBW",
          headerMessage: i18n.getWithExtraData(
            "SELECT_REASONS_OF_ACTION",
            "banned"
          ),
          actionName: "banned",
          fromPage,
          extraData,
          issueAudit: "",
          eventId: -1
        });
      }}
      size={size}
      isEnabled={!disabled}
      text="BAN"
      type="REJECT"
    />
  );
});
export default BanButton;
